import React from 'react';
import './Customer.css';
import { useNavigate } from "react-router-dom";

const Customer = () => {
  const navigate = useNavigate();
  const handleBuildChatbot = () => {
    navigate('/BuildChatBot')
  }
  const handleBookDemo = () => {
    navigate('/bookdemo')
  }
  return (
    <section className="customer-love-section">

      <div className="cta-box">
        <h2 className="heading">Customers <span className="ia-titleGradient">Love Us</span></h2>
        <p className="subtext">Move beyond rule-based chatbots.</p>
        <h3 className="cta-text">
          Adopt <span className="ia-titleGradient">self-guided, self-learning AI agents</span><br />
          for automated customer experiences.
        </h3>
        <div className="cta-buttons">
          <button className="handleButton" onClick={handleBuildChatbot}>Build your AI Agent for Free</button>
          <button className="demobutton" onClick={handleBookDemo}>Get a Demo</button>
        </div>
      </div>
    </section>
  );
};

export default Customer;